export const getCanonicalHref = (canonicalURL: string, href: string) => {
  const url = new URL(href, canonicalURL)
  url.search = ''
  url.hash = ''

  if (!url.pathname) {
    url.pathname = '/'
  }

  const lastSegment = url.pathname.split('/').filter(Boolean).at(-1) ?? ''
  const hasExtension = lastSegment.includes('.')

  if (!hasExtension && !url.pathname.endsWith('/')) {
    url.pathname = `${url.pathname}/`
  }

  return url.toString()
}
